import React from "react";
import { apiURL, apiPrefix } from "../../../utlis/config";
import {
  Input,
  Tooltip,
  message,
  Upload,
  Form,
  Col,
  Select,
  Icon,
  Row,
  Button,
} from "antd";
// import "./examForm.less";
import store from "store";
// import { mediaURL } from "config";
const { Dragger } = Upload;

const imageUpload = (questionsProps) => {
  var { onChangeImage, removeImage, imageUrl, uploadType } = questionsProps;
  // imageUrl: imageUrl,
  //     onChangeImage: this.onChangeImage,
  //     removeImage: this.removeImage,
  const uploadProps = {
    name: "file",
    multiple: false,
    action: `${apiURL}${"/media"}`,
    headers: {
      Authorization: `Bearer ${store.get("authToken")}`,
    },
    onChange(info) {
      const { status, response } = info.file;
      if (status !== "uploading") {
      }
      if (status === "done") {
        if (!response.error && response.status === 200) {
          console.log({
            response: apiURL + response.data,
          });
          // imageUrl = response.data;
          onChangeImage(response.data);
        }
      } else if (status === "error") {
        // that.showErrorMessage("Uploading failed. Please try again");
      }
    },
  };
  return (
    <div className="col-md-12" id="createQuizContainer">
      {!imageUrl ? (
        <Dragger {...uploadProps}>
          <p className="ant-upload-drag-icon">
            <Icon type="picture" />
          </p>
          <p className="uploadText">
            {`Click or drag image to this area to upload `}
            <br />
            {`Image Size 300x200 pixels`}
          </p>
        </Dragger>
      ) : (
        <div className="imageContainer">
          <img
            className="imagePreview"
            src={`${apiURL}${imageUrl}`}
            alt="preview"
          />
          <Button
            className="closeBtn"
            shape="circle"
            icon="close"
            onClick={removeImage}
          />
        </div>
      )}
    </div>
  );
};
export default imageUpload;
